import { Link, useLocation } from "react-router-dom";
import { NAV } from "@/lib/constants";

export const Footer = () => {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <footer className="bg-brand-olive text-brand-cream mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2 max-w-sm">
          <h3 className="font-serif text-3xl text-brand-cream mb-4">Agnes Whitmore</h3>
          <p className="font-body text-brand-cream/80 leading-relaxed italic">
            Timeless recipes, herbal wisdom, and traditional homemaking — lovingly preserved for the modern home.
          </p>
        </div>
        <div>
          <span className="overline text-brand-gold">Explore</span>
          <ul className="mt-4 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="font-body text-sm text-brand-cream/80 hover:text-brand-cream transition-colors">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <span className="overline text-brand-gold">The Cottage</span>
          <ul className="mt-4 space-y-3">
            {[["Contact", "/contact"], ["FAQ", "/faq"], ["Newsletter", "/newsletter"], ["Privacy", "/privacy"], ["Terms", "/terms"], ["Refund Policy", "/refund-policy"], ["Marketing Funnels", "/marketing-funnels"]].map(([l, t]) => (
              <li key={t}>
                <Link to={t} className="font-body text-sm text-brand-cream/80 hover:text-brand-cream transition-colors">{l}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-cream/20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2">
          <p className="font-sans text-[0.7rem] uppercase tracking-[0.14em] text-brand-cream/60">© {new Date().getFullYear()} Agnes Whitmore · Rosewood Cottage</p>
          <p className="font-sans text-[0.7rem] uppercase tracking-[0.14em] text-brand-cream/60">Timeless wisdom for a simpler life</p>
        </div>
      </div>
    </footer>
  );
};
